<template>
  <div>
    <module-header :title="`${year}年销售年度目标完成进度`" :icon-question="false" />
    <div v-loading="loadingStatus"
         element-loading-text="数据加载中……"
         element-loading-spinner="el-icon-loading">
      <div v-if="year">
        <div v-for="(v, k) in tableData" :key="k" style="margin-top: 15px">
          <el-table :data="v" :span-method="objectSpanMethod" border width="800" max-height="500">
            <el-table-column prop="org_nm" label="部门" width="100" align="center" header-align="center" />
            <el-table-column prop="sale_nm" label="销售" width="100" align="center" header-align="center" />
            <el-table-column prop="amount" label="年度目标(W)" width="100" align="center" header-align="center" />
            <el-table-column v-for="month in 12" :key="month" :label="`${month}月(w)`" :prop="`m_${month}`" width="80" align="center"/>
            <el-table-column prop="total_amount" label="截止目前累计完成(W)" width="120" align="center" header-align="center" />
            <el-table-column prop="finish_ratio" label="完成进度" width="80" align="center" header-align="center" />
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getDashboardSaleTargetAmountList} from "@/api/dashboard";
import ModuleHeader from "@/components/summary/ModuleHeader.vue";

export default {
  name: "SummarySaleTargetAmountTable",
  components: {ModuleHeader},
  props: {
    organizationId: [Number, String, Boolean],
    year: {
      type: [Number, String],
      default() {
        return null
      }
    }
  },
  data() {
    return {
      tableData: [],
      rowColSet: [],
      loadingStatus: false,
      switchCompareMonth: false,
      showQuarter: false,
    }
  },
  watch: {
    switchShowQuarter(val) {
      this.showQuarter = val
    }
  },
  methods: {
    // 合并单元格
    // eslint-disable-next-line
    objectSpanMethod({row, rowIndex, columnIndex}) {
      if ([0].includes(columnIndex)) {
        const row_col = this.rowColSet[row.org_id]
        if (rowIndex % row_col === 0) {
          return {
            rowspan: row_col,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    getTableData() {
      this.tableData = [];
      if (this.year) {
        this.loadingStatus = true
        getDashboardSaleTargetAmountList({year: this.year, organization_id: this.organizationId}).then(res => {
          this.loadingStatus = false
          const {model:{list, row_col_set}} = res;
          this.tableData = list;
          this.rowColSet = row_col_set;
        });
      }
    },
  },
  created() {
    this.getTableData()
  }
}
</script>

<style scoped>
</style>
